export const DEFAULT_TASK_DUE_TIME = '11:00';

export const validateTasks = (tasks = []) => {
  if (!tasks?.length) return;

  tasks.forEach((task, i) => {
    if (!task.description?.trim()) {
      throw new Error(`Task ${i + 1}: Please complete the required field(s): Description.`);
    }
    if (task.sendReminder && !task.dueDate) {
      throw new Error(`Task ${i + 1}: A due date is required when "Send a Reminder" is enabled.`);
    }
  });
};

export const processTasksForSubmission = (tasks = [], currentUserId, includeId = false, validate = true) => {
  if (!tasks?.length) {
    return includeId ? [] : undefined;
  }

  if (validate) {
    validateTasks(tasks);
  }

  const validTasks = tasks
    .filter(task => task.description?.trim())
    .map(task => ({
      ...(includeId && task._id && { _id: task._id }),
      ...(task.assignedTo && { assignedTo: task.assignedTo }),
      description: task.description,
      ...(task.dueDate && { dueDate: task.dueDate }),
      dueTime: task.dueTime || DEFAULT_TASK_DUE_TIME,
      ...(task.sendReminder && { sendReminder: true }),
      createdBy: task.createdBy || currentUserId,
      completed: task.completed || false
    }));

  return includeId ? validTasks : (validTasks.length > 0 ? validTasks : undefined);
};

export const createTaskUpdatePayload = (tasks = [], currentUserId) => ({
  tasks: processTasksForSubmission(tasks, currentUserId, true, false)
});
